import React from 'react';
import { Save } from 'lucide-react';

const BlogEditorForm = ({ formData, handleChange, handleSubmit, loading, isEditing }) => (
  <form onSubmit={handleSubmit} className="space-y-6 bg-card border border-border p-6 md:p-8 rounded-xl shadow-sm">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 border-b border-border pb-6">
      <div className="space-y-2">
        <label className="text-sm font-bold uppercase tracking-widest text-muted-foreground">SEO Title</label>
        <input
          name="seo_title"
          value={formData.seo_title}
          onChange={handleChange}
          placeholder="Optimized Title for Search Engines"
          className="w-full bg-background border border-input p-3 rounded-lg focus:ring-2 focus:ring-accent focus:outline-none"
        />
      </div>
      <div className="space-y-2">
        <label className="text-sm font-bold uppercase tracking-widest text-muted-foreground">Meta Description</label>
        <input
          name="meta_description"
          value={formData.meta_description}
          onChange={handleChange}
          placeholder="Brief description for SEO..."
          className="w-full bg-background border border-input p-3 rounded-lg focus:ring-2 focus:ring-accent focus:outline-none"
        />
      </div>
    </div>

    <div className="space-y-2">
      <label className="text-sm font-bold uppercase tracking-widest text-muted-foreground">Post Title</label>
      <input
        required
        name="title"
        value={formData.title}
        onChange={handleChange}
        placeholder="e.g. 5 Secrets to YouTube SEO"
        className="w-full bg-background border border-input p-4 rounded-lg focus:ring-2 focus:ring-accent focus:outline-none text-lg font-heading"
      />
    </div>

    <div className="space-y-2">
      <label className="text-sm font-bold uppercase tracking-widest text-muted-foreground">Featured Image URL</label>
      <input
        name="featured_image"
        value={formData.featured_image}
        onChange={handleChange}
        placeholder="https://example.com/image.jpg"
        className="w-full bg-background border border-input p-3 rounded-lg focus:ring-2 focus:ring-accent focus:outline-none"
      />
    </div>

    <div className="space-y-2">
      <label className="text-sm font-bold uppercase tracking-widest text-muted-foreground">Short Excerpt</label>
      <textarea
        required
        name="excerpt"
        value={formData.excerpt}
        onChange={handleChange}
        rows={2}
        placeholder="A brief summary that appears on the blog list page..."
        className="w-full bg-background border border-input p-4 rounded-lg focus:ring-2 focus:ring-accent focus:outline-none resize-y"
      />
    </div>

    <div className="space-y-2">
      <label className="text-sm font-bold uppercase tracking-widest text-muted-foreground flex justify-between">
        <span>Markdown Content</span>
        <span className="text-xs font-normal normal-case opacity-70">Supports **bold**, # headings, - lists</span>
      </label>
      <textarea
        required
        name="content"
        value={formData.content}
        onChange={handleChange}
        rows={15}
        placeholder="# Your heading here\n\nStart writing your amazing content..."
        className="w-full bg-background border border-input p-4 rounded-lg focus:ring-2 focus:ring-accent focus:outline-none font-mono text-sm resize-y"
      />
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="space-y-2">
        <label className="text-sm font-bold uppercase tracking-widest text-muted-foreground">Author</label>
        <input
          required
          name="author"
          value={formData.author}
          onChange={handleChange}
          className="w-full bg-background border border-input p-3 rounded-lg focus:ring-2 focus:ring-accent focus:outline-none"
        />
      </div>
      <div className="space-y-2">
        <label className="text-sm font-bold uppercase tracking-widest text-muted-foreground">Read Time</label>
        <input
          required
          name="read_time"
          value={formData.read_time}
          onChange={handleChange}
          placeholder="e.g. 5 min read"
          className="w-full bg-background border border-input p-3 rounded-lg focus:ring-2 focus:ring-accent focus:outline-none"
        />
      </div>
      <div className="space-y-2">
        <label className="text-sm font-bold uppercase tracking-widest text-muted-foreground">Category</label>
        <input
          name="category"
          value={formData.category}
          onChange={handleChange}
          placeholder="General"
          className="w-full bg-background border border-input p-3 rounded-lg focus:ring-2 focus:ring-accent focus:outline-none"
        />
      </div>
      <div className="space-y-2">
        <label className="text-sm font-bold uppercase tracking-widest text-muted-foreground">Tags</label>
        <input
          required
          name="tags"
          value={formData.tags}
          onChange={handleChange}
          placeholder="SEO, YouTube, Guide"
          className="w-full bg-background border border-input p-3 rounded-lg focus:ring-2 focus:ring-accent focus:outline-none"
        />
        <p className="text-[10px] text-muted-foreground">Comma separated</p>
      </div>
    </div>

    <div className="pt-4 border-t border-border flex justify-end">
      <button
        type="submit"
        disabled={loading}
        className="bg-accent text-accent-foreground font-bold py-3 px-8 rounded-lg hover:opacity-90 transition-opacity flex items-center gap-2 disabled:opacity-50"
      >
        {loading ? (
          <span className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
        ) : (
          <Save size={18} />
        )}
        {isEditing ? 'Save Changes' : 'Publish Post'}
      </button>
    </div>
  </form>
);

export default BlogEditorForm;